import React, { useState } from 'react';
import Lopa from '../../assets/LopaaLogo.png';
import Button from '../Button';
import { useNavigate } from 'react-router-dom';
import { useSocket } from '../../Contexts/SocketContext';
import { logoutUser } from '../../api/Auth';
import { HiOutlineMenuAlt3 } from 'react-icons/hi';
import { useGuideContext } from '../../Contexts/GuidingContext';

interface sidebarProps {
  children: React.ReactNode;
  supportAndHelpdeskContent?: React.ReactNode;
}

const Sidebar = (props: sidebarProps) => {
  const { disconnectSocket } = useSocket();
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { disabled } = useGuideContext();
  const isDisabled = disabled;
  const handleLogoutClick = async () => {
    try {
      const uuid = sessionStorage.getItem('userUUID');

      if (uuid) {
        const response = await logoutUser(uuid);
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('companyName');
        sessionStorage.removeItem('companyUuid');
        sessionStorage.removeItem('userUUID');
        sessionStorage.removeItem('partyUuid');
        sessionStorage.removeItem('shop');
        sessionStorage.removeItem('GuidingStep');
        sessionStorage.removeItem('businessType');
        sessionStorage.removeItem('guidance');
        sessionStorage.removeItem('key');
        sessionStorage.removeItem('planDetail');
        sessionStorage.removeItem('setting');
        sessionStorage.removeItem('dateTimeFormat');

        disconnectSocket();
        navigate('/');
        if (response.ok) {
        } else {
          console.error('Failed to logout:', await response.text());
        }
      }
    } catch (error) {
      console.error('Error during logout:', error);
    }
  };

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  const { children, supportAndHelpdeskContent } = props;

  return (
    <div
      className={`${
        location.pathname === '/account-setup/faq' ||
        location.pathname === '/account-setup/create-profile' ||
        location.pathname === '/account-setup/integration' ||
        location.pathname === '/account-setup/widgets' ||
        location.pathname === '/account-setup/create-menu' ||
        location.pathname === '/account-setup/create-product'
          ? ' hidden 820:block'
          : ''
      } `}
    >
      <div className="relative h-screen">
        <div
          className={`lg:hidden fixed px-2 py-1 z-50 ${isDisabled ? 'pointer-events-none opacity-50' : ''}`}
        >
          {!isSidebarOpen && (
            <HiOutlineMenuAlt3
              className="text-white text-3xl cursor-pointer"
              onClick={!isDisabled ? toggleSidebar : undefined}
            />
          )}
        </div>

        <div
          className={`fixed top-0 left-0 h-full bg-[#343434] lg:p-6 flex flex-col lg:static transition-transform duration-300 z-50 ${
            isSidebarOpen ? 'translate-x-0' : '-translate-x-full'
          } lg:translate-x-0 lg:flex lg:w-72 w-64`}
        >
          <div className="lg:mb-11 my-6 flex items-center justify-center">
            <img src={Lopa} className="lg:w-24 lg:h-12 w-32 h-16" alt="Matrix AI" />
          </div>

          <div className="overflow-y-auto overflow-x-hidden flex flex-col justify-between h-full">
            <div onClick={toggleSidebar}>{children}</div>
            <div>
              {supportAndHelpdeskContent}
              <div className="flex items-center justify-center mt-5">
                <button
                  type="button"
                  className="self-start py-2 px-5 bg-white text-[#006BEA] rounded-[7px] text-sm font-bold shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                  onClick={handleLogoutClick}
                >
                  Logout
                </button>
              </div>
            </div>
          </div>
        </div>

        {isSidebarOpen && (
          <div
            className=" fixed inset-0 bg-black bg-opacity-50 lg:hidden z-40"
            onClick={toggleSidebar}
          ></div>
        )}
      </div>
    </div>
  );
};

export default Sidebar;
